export interface SeoRouteData {
    title?: string;
    description?: string;
    canonicalPath?: string;
    robots?: string;
    image?: string;
    type?: 'website' | 'article';
    structuredData?: Record<string, unknown> | Array<Record<string, unknown>>;
}

export const SITE_NAME = 'Regarding My Life';
export const SITE_URL = 'https://regardingmylife.com';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/assets/icons/cover.jpeg`;
export const APP_STORE_ID = '6748313837';
export const APP_STORE_URL = 'https://apps.apple.com/za/app/regarding-my-life/id6748313837';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.rml.app';
export const DEFAULT_ROBOTS = 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1';
export const NOINDEX_ROBOTS = 'noindex, nofollow';

export const DEFAULT_DESCRIPTION =
    'Regarding My Life is a digital self-mentorship program that helps professionals grow through guided reflection, practical insight, and a more fulfilling life.';

export const BRAND_LONG_DESCRIPTION =
    'Regarding My Life is a digital self-mentorship program for professionals committed to personal growth, well-being, and a more fulfilling life. Built on two decades of impactful in-person mentorship in South Africa, it offers guided reflections, follow-up notes, and flexible audio, reading, and video content that participants can revisit over time.';

export const ORGANIZATION_STRUCTURED_DATA = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: SITE_NAME,
    url: SITE_URL,
    logo: `${SITE_URL}/logos/logo512.png`,
    description: BRAND_LONG_DESCRIPTION,
    slogan: 'A digital self-mentorship program for professionals seeking a more fulfilling life.',
    knowsAbout: [
        'Self-mentorship',
        'Guided reflection',
        'Personal growth',
        'Professional development',
        'Well-being',
        'Leadership growth',
    ],
    sameAs: [
        'https://www.facebook.com/p/Regarding-My-Life-100083324117529/',
        'https://www.linkedin.com/company/regarding-my-life?originalSubdomain=za',
        'https://www.youtube.com/@Regarding_My_Life',
        'https://open.spotify.com/show/1aUc83K5f50HIdCnvIWUUj',
        APP_STORE_URL,
        PLAY_STORE_URL,
    ],
};

export const WEBSITE_STRUCTURED_DATA = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: SITE_NAME,
    url: SITE_URL,
    description: BRAND_LONG_DESCRIPTION,
};

export const MOBILE_APP_STRUCTURED_DATA = {
    '@context': 'https://schema.org',
    '@type': 'MobileApplication',
    name: SITE_NAME,
    operatingSystem: 'iOS, Android',
    applicationCategory: 'LifestyleApplication',
    description:
        'Access guided reflection, personal growth tools, and mentorship support through the Regarding My Life mobile app.',
    offers: {
        '@type': 'Offer',
        price: '0',
        priceCurrency: 'ZAR',
    },
    sameAs: [
        APP_STORE_URL,
        PLAY_STORE_URL,
    ],
};
